<script setup lang="ts">
import type { Attachment } from '@/models/current-student-advanced-standing-form/api'
import { formatBytes } from '@/models/current-student-advanced-standing-form/upload'

defineProps<{
  tbodyId: string
  attachments: Attachment[]
  deletedAttachmentIds: number[]
  deleteDisabled?: boolean
}>()

const emit = defineEmits<{
  stageDelete: [attachment: Attachment]
}>()
</script>

<template>
  <table class="table table-bordered AttachmentUploadTable">
    <thead>
      <tr>
        <th>File Name</th>
        <th>File Size</th>
        <th class="narrow"></th>
      </tr>
    </thead>
    <tbody :id="tbodyId">
      <tr v-if="attachments.length === 0">
        <td colspan="3">== No Files Saved ==</td>
      </tr>
      <tr
        v-for="attachment in attachments"
        :key="attachment.attachment_id"
        :class="{ disabled_row: deletedAttachmentIds.includes(attachment.attachment_id) }"
      >
        <td>{{ attachment.attachment_file_name }}</td>
        <td>{{ formatBytes(attachment.attachment_file_size) }}</td>
        <td>
          <button
            class="btn btn-danger btn-sm"
            title="Delete"
            type="button"
            :disabled="deleteDisabled"
            @click="emit('stageDelete', attachment)"
          >
            &#x232b;
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>
